// extracted by mini-css-extract-plugin
module.exports = {"SectionB2":"SectionB2_SectionB2__AuR3P"};